/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TierLookupKeyEnum =
  (typeof TierLookupKeyEnum)[keyof typeof TierLookupKeyEnum];

export const TierLookupKeyEnum = {
  Basic: "Basic",
  Premium: "Premium",
  Analyse: "Analyse",
} as const;
